<template>
  <div class="sb-metric-tiles">
    <div
      v-for="(m, i) in metrics"
      :key="i"
      :class="['sb-metric-tile', m.variant || 'default']"
    >
      <span class="sb-metric-label">{{ m.label }}</span>
      <span :class="['sb-metric-val', m.variant]">
        {{ m.value }}
        <span v-if="m.trend" class="sb-metric-trend">{{ m.trend }}</span>
      </span>
    </div>
  </div>
</template>

<script>
/**
 * SbMetricTiles — wrapped card tile row for page-level KPIs.
 *
 * Props:
 *   metrics: Array of {
 *     label: string,      // e.g. 'Total Violations'
 *     value: string|number,
 *     variant?: 'violations' | 'exceptions' | 'warn' | 'neutral' | 'default',
 *     trend?: string,     // optional trend annotation, e.g. '+12%'
 *   }
 */
export default {
  name: 'SbMetricTiles',
  props: {
    metrics: { type: Array, required: true },
  },
};
</script>

<style>
.sb-metric-tiles {
  display: flex;
  gap: 10px;
  padding: 14px 16px;
  flex-wrap: wrap;
}

.sb-metric-tile {
  flex: 1;
  min-width: 100px;
  background: var(--surface2);
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 12px 14px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Violations tile — red tint */
.sb-metric-tile.violations {
  background: var(--sb-error-bg);
  border-color: var(--sb-error-bdr);
}

/* Exceptions tile — amber tint */
.sb-metric-tile.exceptions {
  background: var(--sb-warn-bg);
  border-color: var(--sb-warn-bdr);
}

/* Label — uppercase, above value */
.sb-metric-label {
  font-size: 10px;
  color: var(--text3);
  letter-spacing: 0.04em;
  text-transform: uppercase;
  display: block;
  margin-bottom: 6px;
}

/* Value — large, bold */
.sb-metric-val {
  font-size: 24px;
  font-weight: 700;
  color: var(--blue);
  letter-spacing: -0.02em;
  display: block;
  line-height: 1.1;
}

.sb-metric-val.violations {
  color: var(--sb-error);
}

.sb-metric-val.exceptions,
.sb-metric-val.warn {
  color: var(--sb-warn);
}

.sb-metric-val.neutral {
  color: var(--text);
}

.sb-metric-trend {
  font-size: 11px;
  font-weight: 500;
  margin-left: 4px;
  opacity: 0.75;
}
</style>
